import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import { BASE_URL } from "../../url";
import BookList from './BookCreate';
import { Link, useParams, Navigate } from "react-router-dom";
import validate from '../validate';

const BookView = () => {
  const [bookDetails, setBookDetails] = useState([
    {
      index: Math.random(),
      firstName: "",
      lastName: "",
      mobileNumber: "",
      whatsAppNumber: "",
      email: "",
      age: ""
    }
  ]);

  const [redirect, setRedirect] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");

  async function addParticipant(ev) {
    ev.preventDefault();
    const data = new FormData();
    data.set('bookDetails', JSON.stringify(bookDetails));
    data.set('trekName', trekInfo.trekName);
    data.set('trekId', trekInfo._id);

    const handleModal = (message) => {
      openModal(message);
    };

    const remainingSeats = trekInfo.totalSpots - bookedTrekkers.totalParticipants;

    if (!validate.validateBookingDetails(bookDetails, trekInfo.minAge, handleModal, remainingSeats)) {
      return;
    }

    const response = await fetch(`${BASE_URL}/createTrekkerDetails`, {
      method: 'POST',
      body: data,
      credentials: 'include',
    });
    if (response.ok) {
      setRedirect(true);
    }
  }

  if (redirect) {
    alert("Participants Added Successfully!")
    window.location.href = "/displayAllTreks";
  }

  const { id } = useParams();
  const [trekDetails, setTrekDetails] = useState(null);
  const [bookedTrekkers, setBookedTrekkers] = useState(null);

  useEffect(() => {
    fetch(`${BASE_URL}/trekDetails/${id}`)
      .then(response => {
        response.json().then(trekDetails => {
          setTrekDetails(trekDetails);
        });
      });
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/trekParticipantsCount/${id}`)
      .then(response => {
        response.json().then(bookedTrekkers => {
          setBookedTrekkers(bookedTrekkers);
        });
      });
  }, []);

  const addNewRow = () => {
    setBookDetails(prevState => [
      ...prevState,
      {
        index: Math.random(),
        firstName: "",
        lastName: "",
        mobileNumber: "",
        whatsAppNumber: "",
        email: "",
        age: ""
      }
    ]);
  };

  const clickOnDelete = record => {
    const updatedList = bookDetails.filter(r => r !== record);
    setBookDetails(updatedList);
  };

  let trekInfo;
  if (trekDetails != null) {
    trekInfo = trekDetails;
  }

  const openModal = (message) => {
    setModalContent(message);
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  if (trekInfo) {
    return (
      <div className="content aboutTop">
        <form onSubmit={addParticipant}>
          <div className="postForm">
            <h2 className="trekName">BOOKING DETAILS - {(trekInfo.trekName)} </h2>
            <hr />
            <BookList
              add={addNewRow}
              delete={clickOnDelete}
              bookDetails={bookDetails}
              setBookDetails={setBookDetails}
            />
            <button className="createPost" style={{ marginTop: '5px' }}>PAY NOW</button>
          </div>
        </form>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Alert Modal"
          style={{
            content: {
              width: '90%', 
              maxWidth: '450px', 
              height: '200px',
              maxHeight: '325px', 
              margin: 'auto',
              borderRadius: '8px',
              padding: '25px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              overflow: 'auto',
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1000,
            }
          }}
        >

          <div style={{ marginBottom: '15px' }}>
            <h2 style={{ margin: '0', paddingBottom: '5px', borderBottom: '1px solid #ccc' }} className="trekName">Alert</h2>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <p style={{ margin: '0' }} className="alertText">{modalContent}</p>
          </div>
          <div style={{ float: 'right' }}>
            <button onClick={closeModal}>CLOSE</button>
          </div>
        </Modal>
      </div>
    );
  }
};

export default BookView;